const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArcadeJoyStick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "30.21 3.45 139.95 294.327",
    width: 139.95,
    height: 294.327,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "var(--theme-secondary)"
    },
    cx: 100.185,
    cy: 73.425,
    rx: 69.975,
    ry: 69.975
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "var(--theme-secondary)"
    },
    cx: 101.147,
    cy: 279.983,
    rx: 46.89,
    ry: 17.794
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.922,
    y: 116.468,
    width: 23.565,
    height: 161.592,
    style: {
      fill: "var(--theme-secondary)",
      strokeWidth: 3,
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 7
    },
    rx: 8.98,
    ry: 8.98
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcadeJoyStick);
export default __webpack_public_path__ + "static/media/arcadeJoyStick.8ff38c5fa69095dd0f947a5f691ae768.svg";
export { ForwardRef as ReactComponent };